module.exports = __webpack_public_path__ + "img/avatar_14.8a8943a4.svg";